import css from '@emotion/css';
import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import Icon from 'components/Kizen/Icon';

export const Wrapper = styled.div`
  display: flex;
  margin: 10px 15px;
  align-items: center;
  flex-direction: column;
  height: 100%;
  ${({ padding }) =>
    padding
      ? css`
          padding: 10px 15px;
        `
      : ''}
`;

export const Paragraph = styled.p`
  background-color: var(--color-feedback-info-bg);
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  font-size: 15px;
  line-height: 20px;
  overflow-y: auto;
  color: var(--color-font-primary);

  ${({ center }) =>
    center
      ? css`
          text-align: center;
        `
      : ''}
`;

export const StyledIcon = styled(Icon)`
  && svg {
    height: 30px;
    width: 30px;
  }
  padding: 15px 0;

  &:hover {
    color: var(--color-background-dark);
  }
`;

export const StyledMenuContainer = styled.div`
  display: flex;
  position: absolute;
  right: ${gutters.spacing(3)}px;
`;
